// Copyright 2019 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class HelpWorkflowModuleCatalog {
    static HelpModule: IWorkflowModuleConfig = {
        name: "help",
        modulePath: PLATFORM.moduleName("modules/workflows/Support/HelpModule/HelpModule"),
        title: "Help",
        moduleType: WorkflowModuleType.HelpContainer,
    };
}
